import { Box } from "@mui/material";
import colors from "../../config/colors";
import { colorPalette } from "../../config/colorPalette";
import {
  controlBaseSx,
  focusRingSx,
  hiddenInputSx,
  rowSx,
} from "../_shared/controlStyles";

/**
 * Radio
 *
 * Props:
 * - children: label
 * - disabled, checked, defaultChecked, onChange, name, value: go to the native input.
 *   Radios with the same name form a group (arrow keys move between them).
 * - sx: extra styles for the label row, merged last
 */
const Radio = ({
  children,
  disabled = false,
  sx: sxOverride = {},
  ...rest
}) => (
  <Box component="label" sx={{ ...rowSx(disabled), ...sxOverride }}>
    <Box
      component="input"
      type="radio"
      disabled={disabled}
      {...rest}
      sx={hiddenInputSx}
    />
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        ...controlBaseSx,
        width: 20,
        height: 20,
        borderRadius: "50%",
        backgroundColor: colors.white,
        border: `2px solid ${colorPalette.mercuryAlpha[18]}`,
        "&::after": {
          content: '""',
          display: "none",
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: colorPalette.brand[700],
        },
        "input:checked + &": { borderColor: colorPalette.brand[700] },
        "input:checked + &::after": { display: "block" },
        "input:disabled + &": {
          backgroundColor: colorPalette.mercuryAlpha[5],
          borderColor: colorPalette.mercuryAlpha[8],
        },
        "input:disabled + &::after": {
          backgroundColor: colorPalette.mercuryAlpha[28],
        },
        "input:focus-visible + &": focusRingSx,
      }}
    />
    {children}
  </Box>
);

export default Radio;
